import React, { useState } from 'react';
import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from "./views/VoucherPage/components/Login/Login";
import Home from "./views/VoucherPage/home";
import CustomHeader from "./views/VoucherPage/components/Header";
import Users from "./views/VoucherPage/components/Users/Users";
import { ToastProvider, ProgressIndicator } from "@veneer/core";
import Unauthorized from "./views/Unauthorized";
import TwoFactorSetup from "./views/VoucherPage/components/Login/TwoFactorSetup";

function App() {
    const [isLoading, setIsLoading] = useState(false); // Loading state

    return (
        <ToastProvider>
            <Router>
                <CustomHeader setIsLoading={setIsLoading} />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/unauthorized" element={<Unauthorized />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/TwoFactorSetup" element={ <TwoFactorSetup />} />
                </Routes>
                {isLoading && ( // Show loader if loading
                    <div style={overlayStyle}>
                        <div style={loaderContainerStyle}>
                            <ProgressIndicator appearance="linear" behavior="indeterminate" />
                        </div>
                    </div>
                )}
            </Router>
        </ToastProvider>
    );
}

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
};

const loaderContainerStyle: React.CSSProperties = {
    width: '300px',
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export default App;
